import {getInfo,setUserInfo} from "@/utils/storaage.js"

export default{
    namespaced:true,
    state(){
        return{
            userInfo:getInfo()
        }
    },

    mutations:{
        setUserInfo(state,value){
            state.userInfo=value

            setUserInfo(value)
            
        }
    },

    actions:{

    },


    getters:{

    }
    
}